import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import MaintenancePage from "./components/MaintenancePage";
import tashkii from "./icons/Tashkii.png";
import ytmIcon from "./icons/YouTubeMusic.png";
import appleIcon from "./icons/AppleMusic.png";
import spotifyIcon from "./icons/Spotify.png";
import tidalIcon from "./icons/Tidal.png";
import igIcon from "./icons/IG.png";
import backIcon from './icons/back_icn.png';
import bgMobile from "./bg/bg-mobile-opt.mp4";
import bgLandscape from "./bg/bg-landscape-opt.mp4";
import axios from 'axios';

const TermsConditionsContent = () => {
  const contentRef = useRef(null);
  const scrollInterval = useRef(null);

  useEffect(() => {
    const content = contentRef.current;

    if (content) {
      let scrollStep = 1;

      const startAutoScroll = () => {
        scrollInterval.current = setInterval(() => {
          if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
            clearInterval(scrollInterval.current);
	    scrollInterval.current = null;
          } else {
            content.scrollTop += scrollStep;
          }
        }, 50);
      };

      startAutoScroll();

      const stopAutoScroll = () => {
        clearInterval(scrollInterval.current);
	scrollInterval.current = null;
        content.removeEventListener('wheel', stopAutoScroll, { passive: true });
        content.removeEventListener('touchstart', stopAutoScroll, { passive: true });
      };

      content.addEventListener('wheel', stopAutoScroll, { passive: true });
      content.addEventListener('touchstart', stopAutoScroll, { passive: true });

      return () => {
        content.removeEventListener('wheel', stopAutoScroll, { passive: true });
        content.removeEventListener('touchstart', stopAutoScroll, { passive: true });
        clearInterval(scrollInterval.current);
      };
    }
  }, []);

  return (
  <div className="legal-content-container">
    <div className="legal-content" ref={contentRef}>
      <h1>Terms & Conditions</h1>
      <p><strong>Effective Date:</strong> April 30, 2026</p>

      <h2>Introduction</h2>
      <p>
	  Welcome to Quality Performance Core Ltd ("Quality Performance Core", "qpcore", "we", "us", or "our"). By accessing or using our application, website, or related services, you agree to these Terms & Conditions ("Terms"). Please read them carefully.
      </p>
      <p>
        This page and its content are dedicated to the creative work of <strong>Tashkii</strong>, Pianist & Producer.. All rights to the structure, and materials published here are reserved by Quality Performance Core Ltd, with the exception of logo files and audio/video materials, which belong to Tashkii.
      </p>

      <h2>Use of the Application</h2>
      <p>
        This platform provides access to music, artwork, videos, news, and other creative content related to Tashkii. It may also link to third-party services such as streaming platforms or social networks.
      </p>

      <h2>User Responsibilities</h2>
      <p>
        <strong>Compliance:</strong> You agree to use the application in accordance with all applicable laws and regulations.
      </p>
      <p>
        <strong>Respect for Content:</strong> You agree not to download, redistribute, or reproduce any content without explicit permission, unless such action is clearly permitted (e.g., embedded music players).
      </p>

      <h2>Intellectual Property</h2>
      <p>
        All content and materials are owned by Quality Performance Core Ltd and/or Tashkii, and are protected by intellectual property laws. Unauthorized use is prohibited.
      </p>

      <h2>Limitation of Liability</h2>
      <p>
        Quality Performance Core Ltd is not liable for any indirect, incidental, or consequential damages arising from your use of the application or third-party links provided herein.
      </p>

      <h2>Termination</h2>
      <p>
        We reserve the right to suspend or terminate access to this application
        at any time, without notice, if you breach these Terms or engage in
        unlawful behaviour.
      </p>

      <h2>Governing Law & Jurisdiction</h2>
      <p>
        These Terms are governed by the laws of United Kingdom. Any disputes arising
        out of or in connection with the application shall be submitted to the
        competent courts of London, United Kingdom.
      </p>

      <h2>Changes to Terms</h2>
      <p>
        We may update these Terms periodically. Changes will be effective upon posting to this page.
      </p>

      <h2>Contact Us</h2>
      <p>
        For questions, please contact us at <a href="mailto:contact@qpcore.com">contact@qpcore.com</a>.
      </p>
    </div>
  </div>
);
};

const PrivacyPolicyContent = () => {
  const contentRef = useRef(null);
  const scrollInterval = useRef(null);

  useEffect(() => {
    const content = contentRef.current;

    if (content) {
      let scrollStep = 1;

      const startAutoScroll = () => {
        scrollInterval.current = setInterval(() => {
          if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
            clearInterval(scrollInterval.current);
	    scrollInterval.current = null;
          } else {
            content.scrollTop += scrollStep;
          }
        }, 50);
      };

      startAutoScroll();

      const stopAutoScroll = () => {
        clearInterval(scrollInterval.current);
	scrollInterval.current = null;
        content.removeEventListener('wheel', stopAutoScroll, { passive: true });
        content.removeEventListener('touchstart', stopAutoScroll, { passive: true });
      };

      content.addEventListener('wheel', stopAutoScroll, { passive: true });
      content.addEventListener('touchstart', stopAutoScroll, { passive: true });

      return () => {
        content.removeEventListener('wheel', stopAutoScroll, { passive: true });
        content.removeEventListener('touchstart', stopAutoScroll, { passive: true });
        clearInterval(scrollInterval.current);
      };
    }
  }, []);

  return (
  <div className="legal-content-container">
    <div className="legal-content" ref={contentRef}>
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> April 30, 2026</p>

      <h2>Introduction</h2>
      <p>
        At Quality Performance Core Ltd ("Quality Performance Core", "qpcore", "we", "us", or "our"), we respect your privacy. This Privacy Policy explains how we collect, use, and protect information on this page, which presents the creative work of <strong>Tashkii</strong>, Pianist & Producer.
      </p>

      <h2>Data Controller</h2>
      <p>
        The data controller for any processing that occurs on this page is
        <strong> Quality Performance Core Ltd</strong>.
        For privacy enquiries, contact us at <a href="mailto:contact@qpcore.com">contact@qpcore.com</a>.
      </p>

      <h2>Legal Basis for Processing</h2>
      <p>
        We rely on <em>legitimate interest</em> (Article 6(1)(f) GDPR)
        to measure anonymous button-click events. This minimal tracking is
        necessary to understand engagement with Tashkii’s content while
        avoiding intrusive profiling.
      </p>

      <h2>Information We Collect</h2>
      <p>
        We do not collect personal information directly. Only standard anonymized technical data (browser
        type, device, visit duration) may be gathered by embedded third-party services
        (e.g., Tidal, YouTube, Apple Music, Spotify, Instagram).
      </p>

      <h2>Analytics & Tracking</h2>
      <p>
        We use the <strong>Facebook Conversion API & Telegram Bot API</strong> exclusively on the server side to register button clicks
        (e.g., opening music services or social links). <em>No client-side tracking scripts, cookies, or pixels are
        injected into the React application.</em> The data sent is limited to anonymized event parameters and
        does not contain personally identifiable information.
      </p>

      <h2>How We Use Your Information</h2>
      <p>
        <strong>To Ensure Functionality:</strong> We may use anonymized data to ensure that the website works smoothly on all devices and browsers.
      </p>
      <p>
        <strong>To Improve Experience:</strong> Basic aggregated analytics help us understand which sections attract the most interest and how users interact with the content.
      </p>

      <h2>Information Sharing</h2>
      <p>
        We do not share, sell, or trade any user data. If analytics or third-party embedded services (e.g., Tidal, YouTube, Instagram, Apple Music, Spotify) collect any data, it is governed by their respective privacy policies.
      </p>

      <h2>Data Security</h2>
      <p>
        We implement standard security practices to protect access to this website. Since we do not request personal data, the risk of exposure is minimal.
      </p>

      <h2>Data Retention</h2>
      <p>
        Raw server logs and click events are stored for <strong>no longer than
        30 days</strong>. They are then aggregated for statistics or
        permanently deleted.
      </p>

      <h2>Your Rights</h2>
      <p>
        If EU, UK or Ukrainian privacy law applies to you, you may request
        access to, rectification or erasure of any personal data we hold.
        Submit requests to <a href="mailto:contact@qpcore.com">contact@qpcore.com</a>.
      </p>

      <h2>Children's Privacy</h2>
      <p>
        This site is not intended for children under the age of 13. We do not knowingly collect personal data from children.
      </p>

      <h2>Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Updates will be posted on this page with the corresponding effective date.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have any questions or concerns about this policy, contact us at <a href="mailto:contact@qpcore.com">contact@qpcore.com</a>.
      </p>
    </div>
  </div>
);

}

function App() {
  const [currentStep, setCurrentStep] = useState(0);
  const isMaintenanceMode = false;
  const [isIpAllowed, setIsIpAllowed] = useState(false);

  useEffect(() => {
    const checkIpRoute = async () => {
      try {
        const response = await axios.get("/api/ip/check-ip");
        if (response.data && response.data.allowed === true) {
          setIsIpAllowed(true);
        } else {
          setIsIpAllowed(false);
        }
      } catch (error) {
        console.error("Error checking IP on server:", error);
        setIsIpAllowed(false);
      }
    };

    checkIpRoute();
  }, []);

  const isMaintenanceActive = isMaintenanceMode && !isIpAllowed;

  const sendEvent = async (eventName) => {
    try {
      const response = await fetch('/api/track-event', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          eventName: eventName
        })
      });

      const data = await response.json();
      if (data.success) {
      } else {
        console.error(`Помилка при відправці події "${eventName}":`, data.error);
      }
    } catch (error) {
      console.error(`Помилка при відправці події "${eventName}":`, error);
    }
  };

  const handleLinkClick = (event, eventName, url) => {
    event.preventDefault();

  if(url) {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');

    sendEvent(eventName).then(() => {
      if (newWindow) {
        newWindow.focus();
      }
    }).catch(() => {
      if (newWindow) {
        newWindow.focus();
      }
    });
  } else { 
    sendEvent(eventName).catch(() => {
    });
   }
  };

  const steps = [
    {
      id: 'welcome',
      title: "Tashkii Music",
      description: "Pianist & Producer",
      content: (
        <div className="button-container">
	  <a
            href="https://tashkii.qpcore.com/go/spotify"
            className="button"
            onClick={(e) => handleLinkClick(e, 'Spotify', 'https://tashkii.qpcore.com/go/spotify')}
          >
            <div className="button-content">
              <div className="button-icon-container">
                <img src={spotifyIcon} alt="Spotify" className="button-icon" />
              </div>
              <span className="button-text">Listen on Spotify</span>
            </div>
          </a>
	  <a
            href="https://tashkii.qpcore.com/go/apple-music"
            className="button"
            onClick={(e) => handleLinkClick(e, 'Apple Music', 'https://tashkii.qpcore.com/go/apple-music')}
          >
            <div className="button-content">
              <div className="button-icon-container">
                <img src={appleIcon} alt="Apple Music" className="button-icon" />
              </div>
              <span className="button-text">Listen on Apple Music</span>
            </div>
          </a>
	  <a
            href="https://tashkii.qpcore.com/go/youtube-music"
            className="button"
            onClick={(e) => handleLinkClick(e, 'Youtube Music', 'https://tashkii.qpcore.com/go/youtube-music')}
          >
            <div className="button-content">
              <div className="button-icon-container">
                <img src={ytmIcon} alt="YouTube Music" className="button-icon" />
              </div>
              <span className="button-text">Listen on Youtube Music</span>
            </div>
          </a>
	  <a
            href="https://tashkii.qpcore.com/go/tidal"
            className="button"
            onClick={(e) => handleLinkClick(e, 'Tidal', 'https://tashkii.qpcore.com/go/tidal')}
          >
            <div className="button-content">
              <div className="button-icon-container">
                <img src={tidalIcon} alt="Tidal" className="button-icon" />
              </div>
              <span className="button-text">Listen on Tidal</span>
            </div>
          </a>
          <a
            href="https://tashkii.qpcore.com/go/instagram"
            className="button"
            onClick={(e) => handleLinkClick(e, 'Instagram Profile', 'https://tashkii.qpcore.com/go/instagram')}
          >
            <div className="button-content">
              <div className="button-icon-container">
                <img src={igIcon} alt="Instagram" className="button-icon" />
              </div>
              <span className="button-text">Instagram Profile</span>
            </div>
          </a>
        </div>
      )
    },
    {
      id: 'privacy-policy',
      title: "",
      subtitle: "",
      description: "",
      content: <PrivacyPolicyContent />
    },
    {
      id: 'terms-conditions',
      title: "",
      subtitle: "",
      description: "",
      content: <TermsConditionsContent />
    }	  
  ];

  const handleFooterLinkClick = (stepIndex) => {
    setCurrentStep(stepIndex);
  };

  const handleBackClick = () => {
    if (currentStep !== 0) {
      setCurrentStep(0);
    }
  };

  const renderSteps = () => {
    const step = steps[currentStep];

    return (
      <div
        key={currentStep}
        className={`content visible`}
        id={`step-${currentStep}`}
      >
        {currentStep === 0 && (
          <div className="coin-container">
            <img src={tashkii} alt="qp Core" className="coin" />
          </div>
        )}
        {step.title && <h1 className="slide-down">{step.title}</h1>}
        {step.subtitle && <h2 className="slide-down">{step.subtitle}</h2>}
        {step.description && <p className="slide-up">{step.description}</p>}
        {step.content}
      </div>
    );
  };

  return isMaintenanceActive ? (
    <MaintenancePage/>
  ):(
   <>

    <video
    className="bg-video mobile-bg"
    src={bgMobile}
    autoPlay
    loop
    muted
    playsInline
  />

  <video
    className="bg-video landscape-bg"
    src={bgLandscape}
    autoPlay
    loop
    muted
    playsInline
  />	

    <div className="App">
      <header className="App-header">

    {currentStep === 0 && (
	  <div className="marquee">
	    <span><em>Help me land on Spotify’s algorithmic playlists—just hit follow!</em></span>
	    <span aria-hidden="true"><em>My new track “Jogi(Special Version)” is already LIVE!</em></span>
	  </div>
	)}

        {renderSteps()}
        {currentStep !== 0 && (
          <img
            src={backIcon}
            alt="Back"
            className="back-icon visible"
            onClick={handleBackClick}
          />
        )}
      </header>
      <footer className="footer">
        <div className="footer-content slide-up">
          <button
            className="footer-link"
            onClick={() => handleFooterLinkClick(1)}
          >
            Privacy
          </button>
          <span className="footer-divider">|</span>
          <button
            className="footer-link"
            onClick={() => handleFooterLinkClick(2)}
          >
            Terms
          </button>
          <span className="footer-divider">|</span>
          <span className="footer-copy">© qpCore 2026</span>
        </div>
      </footer>
    </div>
   </>
  );
}

export default App;

